const routePaths = {
  HOME: "/",
  SETTINGS: "/settings",
  RESETPASSWORD: "/reset-password",
  DASHBOARD: "/dashboard",
  RETENTION: "/retention-users",
  VISUALIZATION: "/active-retention-users-visualization",
  MANAGE_USERS: "/manage-users",
  REVIEW_CONTACT_FORM: "/review-contact-form",
  CHAT: "/chat",
  PROFILE_SETTINGS: "/profile-settings",
  BROADCAST_NOTIFICATIONS: "/broadcast-notifications",
  MANAGE_APP_DATA: "/manage-app-data",
  TERMS_CONDITIONS: "/terms-conditions",
  PRIVACY_POLICY: "/privacy-policy",
  MANAGE_CATEGORIES: "/manage-categories",
  NOT_FOUND: "*",
};

export default routePaths;
